import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Home, ArrowUpCircle, ArrowLeftRight, Send, CreditCard, Users, History,
  Shield, Settings, QrCode, Link2, Code, Grid3X3, Award, HelpCircle,
  GraduationCap, LogOut, ChevronLeft, Bell, Copy, CheckCircle
} from "lucide-react";

const CryptoIcon = ({ symbol }) => {
  const icons = {
    USDT: { bg: '#26A17B', text: 'T' }, BTC: { bg: '#F7931A', text: '\u20bf' },
    LTC: { bg: '#345D9D', text: '\u0141' }, BNB: { bg: '#F3BA2F', text: 'B' },
    ETH: { bg: '#627EEA', text: '\u039e' }, TRX: { bg: '#FF0013', text: 'T' },
    USDC: { bg: '#2775CA', text: '$' },
  };
  const icon = icons[symbol] || { bg: '#666', text: '?' };
  return (
    <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{ backgroundColor: icon.bg }}>
      {icon.text}
    </div>
  );
};

const generateRandomId = () => Math.floor(100000 + Math.random() * 900000);

export default function CashinoutMainPreview() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [balances, setBalances] = useState({});
  const [browserTheme, setBrowserTheme] = useState('dark');
  const [randomUserId] = useState(generateRandomId);

  useEffect(() => {
    document.title = 'Главная';
    const tp = searchParams.get('theme');
    if (tp === 'dark' || tp === 'light') setBrowserTheme(tp);
    let fav = document.querySelector("link[rel='icon']");
    if (!fav) { fav = document.createElement('link'); fav.rel = 'icon'; document.head.appendChild(fav); }
    fav.href = 'https://cashinout.io/favicon.ico';
  }, []);

  useEffect(() => {
    const dp = searchParams.get('data');
    if (dp) {
      try {
        const parsed = JSON.parse(decodeURIComponent(dp));
        setData(parsed);
        if (parsed.browserTheme) setBrowserTheme(parsed.browserTheme);
        setBalances({
          USDT: (Math.random() * 500).toFixed(2), BTC: (Math.random() * 0.01).toFixed(6),
          LTC: (Math.random() * 2).toFixed(4), BNB: (Math.random() * 1).toFixed(4),
          ETH: (Math.random() * 0.2).toFixed(5), TRX: (Math.random() * 500).toFixed(2),
          USDC: (Math.random() * 500).toFixed(2),
        });
      } catch (e) { console.error(e); }
    }
  }, [searchParams]);

  const isDark = browserTheme === 'dark';
  const theme = {
    bg: isDark ? '#202124' : '#dee1e6', tabBarBg: isDark ? '#202124' : '#dee1e6',
    activeTabBg: isDark ? '#292a2d' : '#ffffff', inactiveTabBg: isDark ? '#35363a' : '#c9cdd4',
    addressBarBg: isDark ? '#292a2d' : '#ffffff', addressInputBg: isDark ? '#202124' : '#f1f3f4',
    textPrimary: isDark ? '#e8eaed' : '#202124', textSecondary: isDark ? '#9aa0a6' : '#5f6368',
    border: isDark ? '#3c4043' : '#dadce0',
  };

  useEffect(() => {
    document.documentElement.style.backgroundColor = theme.bg;
    document.body.style.backgroundColor = theme.bg;
    document.body.style.margin = "0"; document.body.style.padding = "0";
    return () => { document.documentElement.style.backgroundColor = ""; document.body.style.backgroundColor = ""; };
  }, [theme.bg]);

  if (!data) return <div className="min-h-screen bg-[#f5f7fa] flex items-center justify-center text-gray-600">Загрузка...</div>;

  const accountName = `${data.firstName || ''} ${data.lastName || ''}`.trim() || 'Пользователь';
  const userId = data.cashinoutId || randomUserId;

  const BrowserFrame = () => (
    <div style={{ backgroundColor: theme.tabBarBg }} className="flex-shrink-0">
      <div className="flex items-center h-[38px]" style={{ backgroundColor: theme.tabBarBg }}>
        <div className="flex items-end flex-1 pl-2">
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px]" style={{ backgroundColor: theme.inactiveTabBg }}>
            <img src="https://finance.ozon.ru/favicon.ico" alt="" className="w-4 h-4 mr-2" />
            <span className="text-[13px] truncate" style={{ color: theme.textSecondary }}>Ozon Карта</span>
          </div>
          <div className="flex items-center h-[34px] px-3 rounded-t-lg min-w-[140px] max-w-[200px] mr-[1px]" style={{ backgroundColor: theme.activeTabBg }}>
            <img src="https://cashinout.io/favicon.ico" alt="" className="w-4 h-4 mr-2" />
            <span className="text-[13px] truncate" style={{ color: theme.textPrimary }}>Главная</span>
          </div>
          <button className="w-7 h-7 flex items-center justify-center rounded-full ml-1 mb-1" style={{ color: theme.textSecondary }}>
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          </button>
        </div>
        <div className="flex items-center h-full">
          <button className="w-[46px] h-full flex items-center justify-center" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[1px]" viewBox="0 0 10 1"><rect fill="currentColor" width="10" height="1"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1"><rect x="0.5" y="0.5" width="9" height="9"/></svg></button>
          <button className="w-[46px] h-full flex items-center justify-center hover:bg-[#e81123] hover:text-white" style={{ color: theme.textSecondary }}><svg className="w-[10px] h-[10px]" viewBox="0 0 10 10" stroke="currentColor" strokeWidth="1.2"><line x1="0" y1="0" x2="10" y2="10"/><line x1="10" y1="0" x2="0" y2="10"/></svg></button>
        </div>
      </div>
      <div className="flex items-center h-[40px] px-2" style={{ backgroundColor: theme.addressBarBg }}>
        <div className="flex items-center gap-1 mr-2">
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: theme.textSecondary }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: isDark ? '#5f6368' : '#dadce0' }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg></button>
          <button className="w-8 h-8 flex items-center justify-center rounded-full" style={{ color: theme.textSecondary }}><svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg></button>
        </div>
        <div className="flex-1 flex items-center h-[32px] px-4 rounded-full" style={{ backgroundColor: theme.addressInputBg, border: `1px solid ${theme.border}` }}>
          <svg className="w-4 h-4 mr-3" style={{ color: theme.textSecondary }} viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg>
          <span className="text-[14px]" style={{ color: theme.textPrimary }}>cashinout.io/dashboard</span>
        </div>
      </div>
    </div>
  );

  const menuItems = [
    { icon: Home, label: 'Главная', active: true }, { icon: ArrowUpCircle, label: 'Пополнить' },
    { icon: ArrowLeftRight, label: 'Обмен' }, { icon: Send, label: 'Отправить' },
    { icon: CreditCard, label: 'Виртуальные карты' }, { icon: Users, label: 'Реферальная программа' },
    { icon: History, label: 'История' }, { icon: Shield, label: '2FA' }, { icon: Settings, label: 'Настройки' },
  ];
  const cryptoList = [
    { symbol: 'USDT', name: 'Tether' }, { symbol: 'BTC', name: 'Bitcoin' }, { symbol: 'LTC', name: 'Litecoin' },
    { symbol: 'BNB', name: 'Binance Coin' }, { symbol: 'ETH', name: 'Ethereum' }, { symbol: 'TRX', name: 'TRON' },
    { symbol: 'USDC', name: 'USD Coin' },
  ];

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: theme.bg, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <BrowserFrame />
      <div className="flex-1 flex bg-[#f5f7fa]">
        <aside className="w-56 bg-[#303646] flex flex-col flex-shrink-0">
          <div className="p-4"><img src="/cashinout-logo.png" alt="Cashinout" className="h-8 object-contain" /></div>
          <nav className="flex-1 py-2 overflow-y-auto">
            {menuItems.map((item, i) => {
              const Icon = item.icon;
              return (<a key={i} href="#" className={`flex items-center gap-3 px-4 py-2.5 text-sm ${item.active ? 'text-white bg-[#3d4557]' : 'text-[#9ca3af]'}`}><Icon className="w-5 h-5" /><span>{item.label}</span></a>);
            })}
            <div className="px-4 py-2 mt-4"><span className="text-xs font-medium text-[#6b7280] uppercase">Приложение</span></div>
            <a href="#" className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#9ca3af]"><QrCode className="w-5 h-5" /><span>QR для авторизации</span></a>
            <div className="px-4 py-2 mt-4"><span className="text-xs font-medium text-[#6b7280] uppercase">Для бизнеса</span></div>
            {[{i:Link2,l:'Платёжные ссылки'},{i:Code,l:'API'},{i:Grid3X3,l:'Массовые выплаты'}].map((x,i)=>{const I=x.i;return <a key={i} href="#" className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#9ca3af]"><I className="w-5 h-5"/><span>{x.l}</span></a>;})}
            <div className="mt-4 border-t border-[#3d4557] pt-2">
              {[{i:Award,l:'Тарифы'},{i:HelpCircle,l:'Служба поддержки'},{i:GraduationCap,l:'Академия Cashinout'},{i:HelpCircle,l:'Частые вопросы'},{i:LogOut,l:'Выйти'}].map((x,i)=>{const I=x.i;return <a key={i} href="#" className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#9ca3af]"><I className="w-5 h-5"/><span>{x.l}</span></a>;})}
            </div>
          </nav>
        </aside>
        <div className="flex-1 flex flex-col min-w-0">
          <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-end gap-4">
            <span className="text-sm text-gray-700 font-medium">{accountName}</span>
            <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full flex items-center justify-center">
              <span className="text-white text-xs font-medium">{accountName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}</span>
            </div>
            <div className="text-sm text-gray-600">ID: <span className="font-medium">{userId}</span></div>
            <Copy className="w-5 h-5 text-gray-500" />
            <div className="relative"><Bell className="w-5 h-5 text-gray-500" /><span className="absolute -top-1 -right-1 w-2 h-2 bg-blue-500 rounded-full"></span></div>
          </header>
          <main className="flex-1 p-6 overflow-auto">
            <div className="flex gap-6">
              <div className="flex-1 max-w-xl">
                <div className="flex items-center gap-3 mb-6">
                  <h1 className="text-2xl font-semibold text-gray-900">Главная</h1>
                  <div className="flex items-center gap-1 text-green-500 text-sm"><span>Аккаунт верифицирован</span><CheckCircle className="w-4 h-4" /></div>
                </div>
                <div className="bg-gradient-to-r from-[#1e3a5f] to-[#2d5a87] rounded-xl p-5 mb-6">
                  <h2 className="text-white font-medium text-lg mb-2">Мой Кошелек</h2>
                  <p className="text-gray-300 text-sm mb-1">Основной баланс в USDT</p>
                  <div className="flex items-center gap-2"><span className="text-white text-3xl font-bold">{balances.USDT || '0'}</span><span className="text-white text-xl">USDT</span></div>
                  <div className="flex items-center gap-2 mt-4">
                    {['Обмен','Отправить','Получить'].map((l,i) => (<button key={i} className="flex items-center gap-2 px-4 py-2 bg-white/10 rounded-lg text-white text-sm">{l}</button>))}
                    <button className="flex items-center gap-2 px-4 py-2 bg-[#3b82f6] rounded-lg text-white text-sm ml-auto"><CreditCard className="w-4 h-4" />Оплатить</button>
                  </div>
                </div>
                <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                  <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
                    <h3 className="font-medium text-gray-900">Мои аккаунты</h3>
                    <button className="text-sm text-blue-500">Скрыть нулевые балансы</button>
                  </div>
                  <div className="divide-y divide-gray-100">
                    {cryptoList.map(c => (
                      <div key={c.symbol} className="flex items-center justify-between px-5 py-3 hover:bg-gray-50">
                        <div className="flex items-center gap-3"><CryptoIcon symbol={c.symbol} /><div><div className="font-medium text-gray-900">{c.symbol}</div><div className="text-xs text-gray-500">{c.name}</div></div></div>
                        <span className="font-medium text-gray-900">{balances[c.symbol] || '0'}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="w-96 flex-shrink-0">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Новости</h3>
                <div className="space-y-3">
                  <div className="bg-gradient-to-r from-purple-600 to-purple-500 rounded-xl p-4 text-white"><h4 className="font-bold text-sm">ОПЛАЧИВАЙ STEAM ПРЯМО ИЗ</h4><p className="text-sm opacity-90">ЛИЧНОГО КАБИНЕТА CASHINOUT</p></div>
                  <div className="bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl p-4 text-white"><h4 className="font-bold text-sm">ЧИТАЙ СВЕЖИЕ НОВОСТИ</h4><p className="text-sm opacity-90">В НАШЕМ ТГ-КАНАЛЕ</p></div>
                  <div className="bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl p-4 text-white"><h4 className="font-bold text-sm">СКАЧИВАЙ ПРИЛОЖЕНИЕ</h4><p className="text-sm opacity-90">В GOOGLE PLAY</p></div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
